import { currentI18n } from '../i18n/i18n.js';
import { ApiError } from './api/client.js';

/** Maps any thrown value to a message suitable for end users. */
export function userMessage(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.code === 'VALIDATION_FAILED' && Array.isArray(err.details) && err.details.length > 0) {
      const first = err.details[0] as { message?: unknown };
      if (typeof first.message === 'string') return `${err.message}: ${first.message}`;
    }
    return err.message;
  }
  // Client-side errors are thrown with user-facing messages in the current language.
  if (err instanceof Error && err.message) return err.message;
  return currentI18n().m.common.unexpectedError;
}
